// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__5xyYV","logo__icon":"Logo_logo__icon__V_xGW","logo__icon_mobile":"Logo_logo__icon_mobile__3CEV5","logo__icon_desktop":"Logo_logo__icon_desktop__lr3Wv"};